<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan Customer
          </div>

          <v-row
            class="">
            <v-col 
              cols="10"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <v-col
                          cols="12"
                          md="6" class="pt-0 pr-8">

                          <ValidationProvider
                            name="sales" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Nama sales
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Nama sales"
                              v-on:change="changeSales()"
      
                              
                              :items="sales"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"
      
                              v-model="form.sales_id"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Customer" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Nama customer
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Nama customer"
                              v-on:change="fetchToko()"
      
                              
                              :items="customer"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"
      
                              v-model="form.customer_id"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Nama" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nama
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Nama"
        
                              
        
                              v-model="form.name"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Nama Alias" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nama Alias
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Nama Alias"
        
                              
        
                              v-model="form.name_alias"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>


                          <ValidationProvider
                            name="NIK" 
                            rules="|min:16|max:16" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              NIK
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"
        
                              placeholder="No. NIK"
        
                              
        
                              v-model="form.nik"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Email" 
                            rules="|email" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Email
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Contoh. XXXX@gmail.com"
                              
        
                              v-model="form.email"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Alamat" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Alamat
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Alamat"
                              row="2"
        
                              
        
                              v-model="form.address"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>
        

                          <div>
                            <div class="body-2 mb-2">
                              Mobilephpne
                            </div>
                            <div class="d-flex">
                              <div style="width: 100%;">
                                <v-text-field
                                  filled
                                  rounded
                                  dense
                                  solo

                                  :color="set_color"
                                  placeholder="Contoh. 08xxxxxxxxxxx"

                                  hide-details

                                  v-model="mobilephone.name"
                                  
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </div>
                              <div>
                                <v-btn
                                  class="mx-2 white--text"
                                  fab
                                  @click="addMobilephone()"
                                  :disabled="mobilephone.name === ''"
                                  small
                                  height="50"
                                  width="50"
                                  elevation="0"
                                  color="green"
                                >
                                  <v-icon dark>
                                    mdi-check-bold
                                  </v-icon>
                                </v-btn>
                              </div>
                            </div>

                            <div v-for="(item, index) in form.mobilephone_arr" :key="index" class="mb-3">
                              <div class="d-flex align-center mb-2">
                                <div style="width: 100%;" class="ml-5">
                                  {{ item }}
                                </div>
                                <div class="d-flex">
                                  <v-btn
                                    class="mx-2 white--text"
                                    fab
                                    @click="form.mobilephone_arr.splice(index, 1)"
                                    small
                                    elevation="0"
                                    color="green"
                                  >
                                    <v-icon dark>
                                      mdi-close
                                    </v-icon>
                                  </v-btn>

                                  <v-btn
                                    class="mx-2 white--text"
                                    fab
                                    @click="mobilephone.name = item; mobilephone.id = index;"
                                    small
                                    elevation="0"
                                    color="green"
                                  >
                                    <v-icon dark>
                                      mdi-pencil
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div>

                          </div>

                        </v-col>
                        
                        <v-col
                        cols="12"
                        md="6" class="pt-0 pl-8">
        
                          <ValidationProvider
                            name="NPWP" 
                            rules="|min:15|max:16" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              NPWP
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"
        
                              placeholder="No. NPWP"
        
                              
        
                              v-model="form.npwp"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Plafon" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Plafon
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Plafon"
        
                              
        
                              v-model="form.plafon"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Ketentuan" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Ketentuan
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Ketentuan"
                              row="2"
        
                              
        
                              v-model="form.term"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>


                          <ValidationProvider
                            name="Faktur" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Faktur
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
        
                              placeholder="Faktur"
        
                              
        
                              v-model="form.faktur"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                          

                          <!-- <div v-if="message.ttd.length > 0"
                            class="text-center mt-6">
                            <div
                              class="error--text d-flex align-start">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.ttd }}
                              </span>
                            </div>
                          </div> -->
                          <div class="mt-3">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Tanda Tangan
                            </div>
                            <uploadfolder
                              v-model="upload.ttd" 
                              style="height: 150px; width: 250px">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  height="150"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="form.ttd.length < 1">
                                    <v-icon v-if="!process.ttd"
                                      size="60" 
                                      color="#718EBF">
                                      mdi-cloud-upload-outline
                                    </v-icon>
  
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>
  
                                  <v-img v-else
                                    contain
                                    height="150"
                                    :src="form.ttd" 
                                    :alt="form.ttd"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.ttd"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
  
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadfolder>

                            <ValidationProvider
                            name="Deskripsi" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Deskripsi
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Deskripsi"
                              row="2"
        
                              
        
                              v-model="form.desc"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>
                          </div>


                        </v-col>

                        <v-col cols="6">

                          <ValidationProvider
                            name="Toko" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Pilih Toko
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Pilih Toko"
      
                              
                              :items="toko"
                              item-value="store_id"
                              item-text="store_name"
                              :item-color="set_color"
      
                              v-model="form.store_id"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>

                          <div
                            v-if="form.store_id !== ''">

                            <ValidationProvider
                              name="Nama" 
                              rules="" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Nama
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#718EBF"
                                placeholder="Nama"
          
                                
          
                                v-model="form.store_name"
                                :error-messages="errors"
                                
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
  
                            <ValidationProvider
                              name="Nama Penanggungjawab" 
                              rules="" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Nama Penanggungjawab
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#718EBF"
                                placeholder="Nama Penanggungjawab"
          
                                
          
                                v-model="form.store_pic_name"
                                :error-messages="errors"
                                
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
                          </div>



                        </v-col>

                        <v-col
                        cols="12"
                        md="6" class="pt-0 pl-8"
                        v-if="form.store_id !== ''">
        
                          <ValidationProvider
                            name="Alamat" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Alamat
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Alamat"
                              row="3"
        
                              
        
                              v-model="form.store_address"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>


                        </v-col>

                        <v-col
                          cols="12"
                          class="py-0"
                          v-if="form.store_id !== ''">
                          <label>
                            AutoComplete
                            <gmap-autocomplete
                              placeholder="ketik alamat"
                              class="v-input__slot"
                              @place_changed="setPlace">
                            </gmap-autocomplete>
                          </label>
                          <!-- <div
                            class="d-flex align-center mb-3">
                            <v-btn
                              v-for="(item, index) in menu"
                              :key="index"

                              @click="selected.menu = item; initMap();"

                              :color="selected.menu === item ? set_color : ''"
                              :class="selected.menu === item ? 'white--text' : ''"
                              :style="selected.menu === item ? 'font-weight: 600;' : ''"

                              small
                              rounded
                              elevation="0"
                              class="text-capitalize mr-4">
                              {{ item }}
                            </v-btn>
                          </div> -->

                          <div>
                            <gmap-map
                              :center="center"
                              :zoom="12"
                              :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: true,
                                disableDefaultUi: false
                              }"
                              :clickable="true"
                              @click="updatePlace"
                              style="width: 100%; height: 700px;">

                              <gmap-marker
                                :position="center"
                                :draggable="true"
                                @drag="updatePlace"
                                @click="center = center">
                              </gmap-marker>
                            </gmap-map>
                          </div>

                          <!-- <div v-if="selected.menu === 'Polygon'">
                            <v-card
                              flat
                              min-height="500px"
                              color="transparent"
                              style="border-radius: 10px;">
                              <div 
                                id="map" 
                                style="width: 100%; height: 500px;">
                              </div>
                            </v-card>
                          </div> -->
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pt-6"
                          v-if="form.store_id !== ''">
                          <ValidationProvider 
                            name="Latitude" 
                            rules="" 
                            v-slot="{ errors }">
                            <div class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->

                              Latitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              solo

                              onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. -2.9198476"

                              v-model="form.store_latitude"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pt-6"
                          v-if="form.store_id !== ''">
                          <ValidationProvider 
                            name="Longitude" 
                            rules="" 
                            v-slot="{ errors }">
                            <div class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->

                              Longitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              solo

                              onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. 104.645729"


                              v-model="form.store_longitude"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12"
                          v-if="form.store_id !== ''">
                          <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Catatan
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Catatan"
                              row="3"
        
                              
        
                              v-model="form.store_notes"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-textarea>
                            
                          <div 
                            class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            Gambar 
                          </div>
                          <v-row>
                            <v-col 
                              v-for="(item, index) in form.store_images"
                              :key="index"
                              cols="12"
                              md="4">
                              <v-card 
                                flat
                                width="100%"
                                height="250"
                                class="d-flex align-center justify-center"
                                style="border-radius: 15px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;
                                      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                                <v-img 
                                  alt="megavin" 
                                  width="100%"
                                  height="196"
                                  :src="item"
                                  contain
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>

                                  <div 
                                    @click="form.store_images.splice(index, 1)"
                                    class="cursor-pointer"
                                    style="position: absolute; top: 5px; right: 5px;">
                                    <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                  </div>
                                </v-img>
                              </v-card>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4">
                              <uploadfolder 
                                v-model="upload.images">
                                <div 
                                  slot="activator" 
                                  class="cursor-pointer">
                                  <v-card 
                                    flat
                                    width="100%"
                                    height="250"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                    <v-icon v-if="!process.file"
                                      size="60" 
                                      color="grey">
                                      mdi-cloud-upload-outline
                                    </v-icon>

                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-card>
                                </div>
                              </uploadfolder>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/customer/perubahan"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        place: null,
        form: {
          customer_id: '',
          // sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          address: '',
          desc: '',
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: '',
          store_id: '',
          store_name: '',
          store_pic_name: '',
          store_address: '',
          store_latitude: '-2.9198476',
          store_longitude: '104.645729',
          store_images: [],
          store_notes: '',
          store_is_blokir: '0'
        },
        customer: [],
        menu: ['Koordinat', 'Polygon'],

        selected: {
          row: [],
          freeze: [],
          delete: [],

          menu: 'Koordinat'
        },

        map: null,

        center: {
          lat: -2.9198476, 
          lng: 104.645729
        },

        upload: {
          images: null
        },
        formOld: {
          id: '',
          // sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          faktur: '',
          ttd: '',
          image_url: '',
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          term: ''
        },
        sales: [],
        customer: [],
        toko: [],

        mobilephone: {
          name: '',
          id: ''
        },
        sales_region_id: '',

        upload: {
          ttd: null,
          faktur: null
        },

        process: {
          form: false,

          ttd: false,

          faktur: false,
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              // this.upload.images.map(obj => {
                this.form.store_images.push(
                  this.upload.images.fileuri
                )
              // })

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchSales()
    },
    methods: {
      async fetchSales () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          is_active: 'Aktif',
          limit: 1000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchToko() {
        this.toko = []
        let params = {
          id: this.form.customer_id
        }
  
        await get('admin/customer/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.toko = res.results.data.store
          }
        })
      },
      async fetchCustomor () {
        // this.process.load = true

        // this.limit = pagination.row

        let params = {
          limit: 10000000000000,
          sales_region_id: this.sales_region_id
        }

        // admin/services/data
        
        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          
          if (res.status === 200) {
            this.customer = res.results.data
            
          }
        })
      },
      changeSales() {
        this.sales.map(obj => {
          if (obj.id === this.form.sales_id) {
            this.sales_region_id = obj.sales_region_id
          }
        })

        this.fetchCustomor()
      },
      addMobilephone () {
        if (this.mobilephone.id !== '' ) {
          this.form.mobilephone_arr[this.mobilephone.id] = this.mobilephone.name
        } else {
          this.form.mobilephone_arr.push(
            this.mobilephone.name
          )
        }
        this.mobilephone.name = ''
        this.mobilephone.id = ''
      },
      setDescription(description) {
        this.description = description;
      },
      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
          this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },
      async fetchCustomer() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.customer = res.results.data
          }
        })
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -2.9198476, 
              lng: 104.645729
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form,
            mobilephone_arr: JSON.stringify(this.form.mobilephone_arr),
            store_images: JSON.stringify(this.form.store_images)
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/customer_edit/submission_data`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/customer/perubahan' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>